export default ({}) => {
    return {
        xAxis: {
            type: "category",
            tickInterval: null,
        },
    };
};
